import { FolderContents } from './GraphMemoryEditor';

const compareValue = (a: unknown, b: unknown) => {
  if (typeof a !== typeof b) return false;

  if (typeof a !== 'object' && typeof b !== 'object') {
    return a === b;
  }

  if (a == null || b == null) {
    return (a || null) === (b || null);
  }

  return JSON.stringify(a) === JSON.stringify(b);
};

export const isEmptyValueFilter = (
  value: Record<string, unknown> | undefined
) => {
  if (!value) return true;
  return !Object.keys(value).length;
};

export const isEmptyKeyFilter = (value: string | undefined) => {
  return !value;
};

export const isEmptyFilter = (filter: {
  key?: string;
  value?: Record<string, unknown>;
}) => isEmptyKeyFilter(filter.key) && isEmptyValueFilter(filter.value);
export const filterItems = (
  items: FolderContents['items'] | undefined,
  filter: {
    key?: string;
    value?: Record<string, unknown>;
  }
) => {
  return (
    items?.filter((item) => {
      if (filter.key && !item.key.includes(filter.key)) {
        return false;
      }

      if (filter.value) {
        for (const [key, value] of Object.entries(filter.value)) {
          if (!compareValue(value, item.value[key])) return false;
        }
      }

      return true;
    }) ?? []
  );
};
